<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';
import { signOut } from 'firebase/auth';
import Menubar from 'primevue/menubar';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useDebugUser } from '@/composables/useDebugUser';
import { auth } from '../firebase';
import LogoWithBall from './Logo-with-ball.vue';

const router = useRouter();

const items: MenuItem[] = [
  ...(import.meta.env.DEV
    ? [{
        label: 'Admin',
        icon: 'pi pi-cog',
        command: () => router.push('/admin'),
      }]
    : []),
  {
    label: 'Dashboard',
    icon: 'pi pi-home',
    command: () => router.push('/'),
  },
  {
    label: 'Data Management',
    icon: 'pi pi-database',
    items: [
      {
        label: 'Sessions',
        icon: 'pi pi-file',
        command: () => router.push('/sessions'),
      },
      {
        label: 'Upload Data',
        icon: 'pi pi-upload',
        command: () => router.push('/upload'),
      },
    ],
  },
  {
    label: 'Analysis',
    icon: 'pi pi-chart-bar',
    items: [
      {
        label: 'Visualization',
        icon: 'pi pi-chart-scatter',
        command: () => router.push('/visualization'),
      },
      {
        label: 'Club Data',
        command: () => router.push('/clubdata'),
        icon: 'pi pi-chart-bar',
      },
    ],
  },
  {
    label: 'AI Features',
    icon: 'pi pi-bolt',
    items: [
      {
        label: 'AI Reports',
        icon: 'pi pi-file',
        command: () => router.push('/reports'),
      },
      {
        label: 'Practice Plans',
        icon: 'pi pi-bolt',
        command: () => router.push('/drills'),
      },
      {
        label: 'Trends',
        icon: 'pi pi-chart-line',
        command: () => router.push('/trends'),
      },
      {
        label: 'Recommendations',
        icon: 'pi pi-star',
        command: () => router.push('/recommendations'),
      },
    ],
  },
  {
    label: 'Account',
    icon: 'pi pi-user',
    items: [
      {
        label: 'Settings',
        icon: 'pi pi-cog',
        command: () => router.push('/account'),
      },
      {
        label: 'Support',
        icon: 'pi pi-question-circle',
        command: () => router.push('/support'),
      },
      {
        separator: true,
      },
      {
        label: 'Logout',
        icon: 'pi pi-power-off',
        class: 'text-red-600',
        command: () => {
          signOut(auth).then(() => {
            router.push('/login');
          });
        },
      },
    ],
  },
];

const user = useDebugUser();
const isLoggedIn = computed(() => !!user.value);
</script>

<template>
  <div
    v-if="isLoggedIn"
    class="flex justify-between items-center mb-4 shadow-sm bg-white dark:bg-[var(--p-menubar-background)] text-black dark:text-white"
  >
    <router-link to="/">
      <LogoWithBall class="w-48 ml-4 text-black dark:text-white" />
    </router-link>
    <Menubar :model="items" />
  </div>
</template>

<style scoped>
:deep(.p-menubar) {
  border: none;
}
:deep(.p-menubar-mobile .p-menubar-root-list) {
  width: 14rem;
  left: unset;
  right: 0;
}
</style>
